import type { IObservableArray } from 'mobx';
import type { Dispatch, SetStateAction } from 'react';
import { useState } from 'react';

import type { Recommendation } from '@feathr/blackbox';

interface IUseSelectedRecommendationProps {
  /** The recommendation models */
  recommendations: IObservableArray<Recommendation>;
}

interface IUseSelectedRecommendationReturnProps {
  /** The selected recommendation */
  selectedRecommendation?: Recommendation;
  /** Function to set the selected recommendation ID */
  setSelectedRecommendationId: Dispatch<SetStateAction<string | null>>;
}

/**
 * Hook to manage the selected recommendation. This is used to open the recommendation modal.
 * @param recommendations - The recommendations collection
 * @returns The selected recommendation and a function to set the selected recommendation
 */
function useSelectedRecommendation({
  recommendations,
}: IUseSelectedRecommendationProps): IUseSelectedRecommendationReturnProps {
  const [selectedRecommendationId, setSelectedRecommendationId] = useState<string | null>(null);

  const selectedRecommendation = recommendations.find(
    (recommendation) => recommendation.id === selectedRecommendationId,
  );

  return {
    setSelectedRecommendationId,
    selectedRecommendation,
  };
}

export default useSelectedRecommendation;
